import { RefObject, useCallback, useRef } from 'react';
import { View } from 'react-vega';

export const useSignal = (viewRef: RefObject<View | null>) => {
  // Each update sets its signal and runs the dataflow before the next one is
  // applied. Vega serializes concurrent runAsync calls itself, so this chain is
  // not what keeps the view consistent — it only orders the updates issued
  // through this hook instance, not those other hooks send to the same view.
  const promiseRef = useRef<Promise<void>>(Promise.resolve());

  return useCallback(
    (name: string, value: unknown) => {
      promiseRef.current = promiseRef.current
        .then(async () => {
          viewRef.current?.signal(name, value);

          await viewRef.current?.runAsync();
        })
        // A failed run must not leave the chain rejected, as every later update
        // would then be dropped without a trace.
        .catch((error) => console.error('Vega signal update failed', error))
        .finally(() => {
          globalThis.dispatchEvent(new CustomEvent('resizevegachart'));
        });
    },
    [viewRef]
  );
};
